import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Robot,
  ChartLineUp,
  Clock,
  Globe,
  Prohibit,
  ArrowCounterClockwise,
  Gear
} from '@phosphor-icons/react';

const ANALYTICS_OPTIONS = [
  { id: 'support_analytics', title: 'Support Analytics', desc: 'Bot sessions & handler performance', icon: Robot, color: 'text-purple-600', bg: 'bg-purple-50', path: '/admin/support-analytics' },
  { id: 'client_activity', title: 'Client Activity Dashboard', desc: 'Real-time activity tracking', icon: ChartLineUp, color: 'text-blue-500', bg: 'bg-blue-50', path: '/admin-activity' },
  { id: 'inactive_clients', title: 'Inactive Clients Tracker', desc: 'PDF export - Re-engagement', icon: Clock, color: 'text-red-500', bg: 'bg-red-50', path: '/inactive-clients' },
  { id: 'same_ip', title: 'Clients with Same IP', desc: 'Duplicate detection', icon: Globe, color: 'text-cyan-500', bg: 'bg-cyan-50', path: '/admin/clients-by-ip' },
  { id: 'blocked_clients', title: 'Blocked Clients', desc: 'Blocked users list', icon: Prohibit, color: 'text-red-600', bg: 'bg-red-50' },
  { id: 'revert_requests', title: 'Revert Requests', desc: 'Handler-submitted revert approvals', icon: ArrowCounterClockwise, color: 'text-indigo-500', bg: 'bg-indigo-50' },
  { id: 'mb_config', title: 'MB Setup Configuration', desc: 'Labels + Auto-route', icon: Gear, color: 'text-orange-500', bg: 'bg-orange-50', path: '/admin/mb-config' }
];

export default function AnalyticsHub({ onSubSectionClick }) {
  const navigate = useNavigate();

  const handleOptionClick = (option) => {
    if (option.path) {
      navigate(option.path);
    } else {
      onSubSectionClick(option.id);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="border-b pb-3 mb-6">
        <h2 className="text-xl font-bold text-gray-800">Analytics</h2>
        <p className="text-sm text-gray-500">Admin Control Center</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {ANALYTICS_OPTIONS.map((option) => {
          const Icon = option.icon;
          return (
            <button
              key={option.id}
              onClick={() => handleOptionClick(option)}
              className="flex items-start gap-4 p-5 bg-white border border-gray-150 rounded-xl hover:shadow-md hover:border-gray-300 transition-all text-left duration-200 cursor-pointer focus:outline-none"
            >
              <div className={`p-3 rounded-lg ${option.bg} ${option.color} flex-shrink-0`}>
                <Icon size={24} weight="fill" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-bold text-gray-800 text-sm truncate">{option.title}</h3>
                <p className="text-xs text-gray-400 mt-0.5 line-clamp-2 leading-relaxed">{option.desc}</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
